import config from './config';
import { isPatientAppType, isPatientMobileClient, isPatientPortalWebClient } from './app-utils';
import { isGlobalAud } from './aud-utils';
import constants from './constants';
import { getUnifiedLoginRolloutDecision } from './cookie-utils';

const isRolledOut = ({ unifiedPatientLoginRollout, aud }) => {
  if (unifiedPatientLoginRollout === true) return true;
  if (unifiedPatientLoginRollout === false && !isGlobalAud(aud)) return false;
  return getUnifiedLoginRolloutDecision();
};

// A webview cannot be relied on to keep the rollout cookie, so the app decides for itself and
// replays the decision on the authorize URL.
const isMobileRolledOut = (loginExperience) =>
  loginExperience === constants.NEW_LOGIN_EXPERIENCE;

const showPatientLogo = ({ aud, clientId, loginExperience, apiResponse }) => {
  const { appType, unifiedPatientLoginRollout } = apiResponse;
  if (!isPatientAppType(appType) || !config.unifiedPatientLoginEnabled || !config.patientLogoUrl) {
    return false;
  }
  if (isPatientMobileClient(clientId)) {
    return isMobileRolledOut(loginExperience);
  }
  return isPatientPortalWebClient(clientId)
    && isRolledOut({ unifiedPatientLoginRollout, aud });
};

export const fetchLogoProps = ({ idp, aud, clientId, loginExperience, apiResponse = {} }) => {
  if (idp) {
    return {};
  }
  return showPatientLogo({ aud, clientId, loginExperience, apiResponse })
    ? { logoText: 'athenaPatient', logoUrl: config.patientLogoUrl }
    : { logoText: 'athenahealth', logoUrl: config.logoUrl };
};
